import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import Login from './components/Login/Login';
import Recuperar from './components/Login/Recuperar';

import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import Main from './components/Main/Init'
import Footer from './components/Footer/Footer';

import Structure from './components/WEBContent/Structure/Init'

import Utilizador from './components/Entities/Utilizador/Init'
import Instrutor from './components/Entities/Instrutor/Init'
import Colaborador from './components/Entities/Colaborador/Init'
import Cliente from './components/Entities/Cliente/Init'
import Empresa from './components/Entities/Empresa/Init'
import Empresa01 from './components/Entities/Empresa01/Init'

import Empresa02 from './components/Entities/Empresa02/Init'
import Entidade02 from './components/Entities/Entidade02/Init'


import Company from './components/Entities/Company/Init'
import Entidade from './components/Entities/Entidade/Init'
import Entidade_externa from './components/Entities/Entidade_externa/Init'


import EntidadeForm from './components/Entities/EntidadeForm/Init'

import Agenda from './components/Agenda/Init'
import Evento from './components/Evento/Init'
import EventType from './components/Evento/EventType/Init'
import Forms from './components/Forms/Init'
import FormsType from './components/Forms/FormsType/Init'
import Calendar_Event from './components/Calendar/Event/Init'
import Calendar_Category from './components/Calendar/Category/Init'

import CalendarCopy from "./components/CalendarCopy/Event/Init"

import Content from './components/WEBContent/Content/Init'
import Content_News from './components/WEBContent/News/Init'
import Content_Press from './components/WEBContent/Press/Init'
import Content_Banner from './components/WEBContent/Banner/Init'
import Content_Gallery from './components/WEBContent/Gallery/Init'
import Content_Testemony from './components/WEBContent/Testemony/Init'
import Content_Category from './components/WEBContent/Category/Init'

import Content_Corporate from './components/WEBContent/Corporate/Init'

import Tarefa from './components/Tarefa/Init'
import Intranet_Projetos from './components/Projetos/Init'
import Intranet_Suporte from './components/Suporte/Init'
import Intranet_Department from './components/Intranet/Department/Init'
import Intranet_Groups from './components/Intranet/Groups/Init'

import Intranet_Entity_Category from './components/Intranet/Entity/Category/Init'
import Intranet_Entity_Dimension from './components/Intranet/Entity/Dimension/Init'
import Intranet_Entity_Function from './components/Intranet/Entity/Function/Init'
import Intranet_Entity_Nature from './components/Intranet/Entity/Nature/Init'
import Intranet_Entity_Relation from './components/Intranet/Entity/Relation/Init'
import Intranet_Entity_Sector from './components/Intranet/Entity/Sector/Init'
import Intranet_Entity_Type from './components/Intranet/Entity/Type/Init'

import Intranet_Quality_DocumentType from './components/Intranet/Quality/DocumentType/Init'
import Intranet_Quality_RetentionTime from './components/Intranet/Quality/RetentionTime/Init'
import Intranet_Quality_StorageType from './components/Intranet/Quality/StorageType/Init'
import Intranet_Quality_Document from './components/Intranet/Quality/Document/Init'
import Intranet_Quality_DocumentObsolete from './components/Intranet/Quality/DocumentObsolete/Init'
import Intranet_Quality_DocumentDeleted from './components/Intranet/Quality/DocumentDeleted/Init'
import Intranet_Quality_OccurrenceType from './components/Intranet/Quality/OccurrenceType/Init'
import Intranet_Quality_OccurrenceOrigin from './components/Intranet/Quality/OccurrenceOrigin/Init'
import Intranet_Quality_OccurrenceState from './components/Intranet/Quality/OccurrenceState/Init'
import Intranet_Quality_Occurrence from './components/Intranet/Quality/Occurrence/Init'
import Intranet_Quality_AuditManagement from './components/Intranet/Quality/AuditManagement/Init'
import Intranet_Quality_MonitoringIndicators from './components/Intranet/Quality/MonitoringIndicators/Init'
import Intranet_Quality_EPI from './components/Intranet/Quality/EPI/Init'

import Intranet_Quality_StrategyType from './components/Intranet/Quality/StrategyType/Init'
import Intranet_Quality_StrategyImportance from './components/Intranet/Quality/StrategyImportance/Init'
import Intranet_Quality_StrategyUrgency from './components/Intranet/Quality/StrategyUrgency/Init'
import Intranet_Quality_StrategyClassification from './components/Intranet/Quality/StrategyClassification/Init'
import Intranet_Quality_Strategy from './components/Intranet/Quality/Strategy/Init'
import Intranet_Quality_StrategyBetsRisks from './components/Intranet/Quality/StrategyBetsRisks/Init'
import Intranet_Quality_Formation from './components/Intranet/Quality/Formation/Init'
import Intranet_Quality_SupplierEvaluation from './components/Intranet/Quality/SupplierEvaluation/Init'
import Intranet_Quality_SupplierEvaluationType from './components/Intranet/Quality/SupplierEvaluationType/Init'
import Intranet_Quality_SupplierQualityType from './components/Intranet/Quality/SupplierQualityType/Init'
import Intranet_Quality_SupplyQualityType from './components/Intranet/Quality/SupplyQualityType/Init'
import Intranet_Quality_SupplyType from './components/Intranet/Quality/SupplyType/Init'
import Intranet_Quality_FormationClassificationType from './components/Intranet/Quality/FormationClassificationType/Init'
import Intranet_Quality_FormationStateType from './components/Intranet/Quality/FormationStateType/Init'
import Intranet_Quality_EPI_Type from './components/Intranet/Quality/EPI_Type/Init'

import Intranet_CRM_Opportunity from './components/Intranet/CRM/Opportunity/Init'
import Intranet_CRM_StageType from './components/Intranet/CRM/StageType/Init'
import Intranet_CRM_ComType from './components/Intranet/CRM/ComType/Init'

import Intranet_Maintenance_ActiveType from './components/Intranet/Maintenance/ActiveType/Init'
import Intranet_Maintenance_ActiveState from './components/Intranet/Maintenance/ActiveState/Init'
import Intranet_Maintenance_Active from './components/Intranet/Maintenance/Active/Init'
import Intranet_Maintenance_RepairType from './components/Intranet/Maintenance/RepairType/Init'
import Intranet_Maintenance_Repair from './components/Intranet/Maintenance/Repair/Init'
import Intranet_Maintenance_Orders from './components/Intranet/Maintenance/Maintenance_Orders/Init'
import Intranet_Maintenance_Maintenance_Planeamento from './components/Intranet/Maintenance/Planeamento/Init'
import Intranet_Maintenance_Periodicity from './components/Intranet/Maintenance/Periodicity/Init'
import Intranet_Maintenance_Intervention from './components/Intranet/Maintenance/Intervention/Init'
import Intranet_Maintenance_Priority from './components/Intranet/Maintenance/Priority/Init'
import Intranet_Maintenance_EnergyType from './components/Intranet/Maintenance/EnergyType/Init'
import Intranet_Maintenance_Cost from './components/Intranet/Maintenance/Maintenance_Cost/Init'
import Intranet_Maintenance_Energy from './components/Intranet/Maintenance/Energy/Init'

import Intranet_Maintenance_RMMType from './components/Intranet/Maintenance/RMMType/Init'


import Intranet_Geral_License from './components/Intranet/Geral/License/Init'
import Intranet_Quality_License from './components/Intranet/Quality/License/Init'
import Intranet_CRM_License from './components/Intranet/CRM/License/Init'
import Intranet_Maintenance_License from './components/Intranet/Maintenance/License/Init'

import AppPerfil from './components/WEBContent/PerfisMenus/Init'
import EntityPerfil from './components/WEBContent/PerfisMenusEntidade/Init'


import useToken from './UseToken';
import { getTokenInfo } from './UseToken';

import Hosts from './Hosts';

import {
  set_language,
  repo_favicon_link,
} from './Utils';

document.title = `${document.title}`

//if (process.env.REACT_APP_MODE === 'production') console.log = function () { };

function App() {

  const { token, setToken } = useToken();

  const [isloading, setLoading] = useState(true);

  const handleFavIcon = () => {
    function getFaviconEl() {
      return document.getElementById("favicon");
    }

    const favicon = getFaviconEl(); // Accessing favicon element

    favicon.href = repo_favicon_link("favicon.ico");
  };

  handleFavIcon()


  const change_lang = (l) => {
    set_language(l)
    window.location.reload()

    //console.log('language', localStorage.getItem('lang'))
    //console.log('localstorage', localStorage)
  }

  useEffect(() => {
    // if (localStorage.getItem('lang') !== undefined && localStorage.getItem('lang') !== null && localStorage.getItem('lang') !== 'pt' && localStorage.getItem('lang') !== 'en') {
    //   change_lang('pt')
    // }

    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null) {
      change_lang('pt')
    }

    if (token) {
      setLoading(false)
    }

    return () => { };

  }, [token])

  if (!token) {
    //console.log('---> APP.JS: ANTES DO TOKEN')
    return <Login setToken={setToken} />
  }
  else {

    if (getTokenInfo() === undefined)
      return <Login setToken={setToken} />

    if (getTokenInfo().companycode !== Hosts.companycode)
      return <Login setToken={setToken} />

  }

  let checkAuthorization = (path, component) => {
    return component
  }

  return isloading ?
    <Loader />
    :
    <>
      <Header />
      <Sidebar
      /*
      sidebar_info = {
        sideBarData
      }
      */
      />
      <div className="main-content">

        <Switch>

          <Route path={Main.view.endpoint} exact
            component={checkAuthorization(Main.view, Main.view.component)}
          />

          <Route path={Structure.regist.endpoint} exact
            component={checkAuthorization(Structure.regist.endpoint, Structure.regist.component)}
          />

          <Route path={Structure.list.endpoint} exact
            component={checkAuthorization(Structure.list.endpoint, Structure.list.component)}
          />

          <Route path={Structure.view.endpoint} exact
            component={checkAuthorization(Structure.view.endpoint, Structure.view.component)}
          />

          <Route path={Utilizador.regist.endpoint} exact
            component={checkAuthorization(Utilizador.regist.endpoint, Utilizador.regist.component)}
          />

          <Route path={Utilizador.list.endpoint} exact
            component={checkAuthorization(Utilizador.list.endpoint, Utilizador.list.component)}
          />

          <Route path={Utilizador.view.endpoint} exact
            component={checkAuthorization(Utilizador.view.endpoint, Utilizador.view.component)}
          />

          <Route path={Instrutor.regist.endpoint} exact
            component={checkAuthorization(Instrutor.regist.endpoint, Instrutor.regist.component)}
          />

          <Route path={Instrutor.list.endpoint} exact
            component={checkAuthorization(Instrutor.list.endpoint, Instrutor.list.component)}
          />

          <Route path={Instrutor.view.endpoint} exact
            component={checkAuthorization(Instrutor.view.endpoint, Instrutor.view.component)}
          />

          <Route path={Instrutor.scale.endpoint} exact
            component={checkAuthorization(Instrutor.scale.endpoint, Instrutor.scale.component)}
          />

          <Route path={Colaborador.regist.endpoint} exact
            component={checkAuthorization(Colaborador.regist.endpoint, Colaborador.regist.component)}
          />

          <Route path={Colaborador.list.endpoint} exact
            component={checkAuthorization(Colaborador.list.endpoint, Colaborador.list.component)}
          />

          <Route path={Colaborador.view.endpoint} exact
            component={checkAuthorization(Colaborador.view.endpoint, Colaborador.view.component)}
          />

          <Route path={Cliente.regist.endpoint} exact
            component={checkAuthorization(Cliente.regist.endpoint, Cliente.regist.component)}
          />

          <Route path={Cliente.list.endpoint} exact
            component={checkAuthorization(Cliente.list.endpoint, Cliente.list.component)}
          />

          <Route path={Cliente.view.endpoint} exact
            component={checkAuthorization(Cliente.view.endpoint, Cliente.view.component)}
          />

          <Route path={Empresa.regist.endpoint} exact
            component={checkAuthorization(Empresa.regist.endpoint, Empresa.regist.component)}
          />

          <Route path={Empresa.list.endpoint} exact
            component={checkAuthorization(Empresa.list.endpoint, Empresa.list.component)}
          />

          <Route path={Empresa.view.endpoint} exact
            component={checkAuthorization(Empresa.view.endpoint, Empresa.view.component)}
          />

          <Route path={Empresa01.regist.endpoint} exact
            component={checkAuthorization(Empresa01.regist.endpoint, Empresa01.regist.component)}
          />

          <Route path={Empresa01.list.endpoint} exact
            component={checkAuthorization(Empresa01.list.endpoint, Empresa01.list.component)}
          />

          <Route path={Empresa01.view.endpoint} exact
            component={checkAuthorization(Empresa01.view.endpoint, Empresa01.view.component)}
          />

          <Route path={Empresa02.regist.endpoint} exact
            component={checkAuthorization(Empresa02.regist.endpoint, Empresa02.regist.component)}
          />

          <Route path={Empresa02.list.endpoint} exact
            component={checkAuthorization(Empresa02.list.endpoint, Empresa02.list.component)}
          />

          <Route path={Empresa02.view.endpoint} exact
            component={checkAuthorization(Empresa02.view.endpoint, Empresa02.view.component)}
          />

          <Route path={Empresa02.country.endpoint} exact
            component={checkAuthorization(Empresa02.country.endpoint, Empresa02.country.component)}
          />

          <Route path={Entidade.regist.endpoint} exact
            component={checkAuthorization(Entidade.regist.endpoint, Entidade.regist.component)}
          />

          <Route path={Entidade.list.endpoint} exact
            component={checkAuthorization(Entidade.list.endpoint, Entidade.list.component)}
          />

          <Route path={Entidade.view.endpoint} exact
            component={checkAuthorization(Entidade.view.endpoint, Entidade.view.component)}
          />

          <Route path={Entidade_externa.regist.endpoint} exact
            component={checkAuthorization(Entidade_externa.regist.endpoint, Entidade_externa.regist.component)}
          />

          <Route path={Entidade_externa.list.endpoint} exact
            component={checkAuthorization(Entidade_externa.list.endpoint, Entidade_externa.list.component)}
          />

          <Route path={Entidade_externa.view.endpoint} exact
            component={checkAuthorization(Entidade_externa.view.endpoint, Entidade_externa.view.component)}
          />





          <Route path={EntidadeForm.regist.endpoint} exact
            component={checkAuthorization(EntidadeForm.regist.endpoint, EntidadeForm.regist.component)}
          />

          <Route path={EntidadeForm.list.endpoint} exact
            component={checkAuthorization(EntidadeForm.list.endpoint, EntidadeForm.list.component)}
          />

          <Route path={EntidadeForm.view.endpoint} exact
            component={checkAuthorization(EntidadeForm.view.endpoint, EntidadeForm.view.component)}
          />




          <Route path={Entidade02.regist.endpoint} exact
            component={checkAuthorization(Entidade02.regist.endpoint, Entidade02.regist.component)}
          />

          <Route path={Entidade02.list.endpoint} exact
            component={checkAuthorization(Entidade02.list.endpoint, Entidade02.list.component)}
          />

          <Route path={Entidade02.view.endpoint} exact
            component={checkAuthorization(Entidade02.view.endpoint, Entidade02.view.component)}
          />

          <Route path={Entidade02.detalhesEntidade.endpoint} exact
            component={checkAuthorization(Entidade02.detalhesEntidade.endpoint, Entidade02.detalhesEntidade.component)}
          />

          <Route path={Company.components.base.path} exact
            component={checkAuthorization(Company.components.base.path, Company.components.base.component)}
          />

          <Route path={Company.components.regist.path} exact
            component={checkAuthorization(Company.components.list.path, Company.components.regist.component)}
          />

          <Route path={Company.components.view.path} exact
            component={checkAuthorization(Company.components.view.path, Company.components.view.component)}
          />

          <Route path={Agenda.view.endpoint} exact
            component={checkAuthorization(Agenda.view, Agenda.view.component)}
          />

          {/* Eventos */}
          <Route path={Evento.list.endpoint} exact
            component={checkAuthorization(Evento.list, Evento.list.component)}
          />

          <Route path={Evento.view.endpoint} exact
            component={checkAuthorization(Evento.view, Evento.view.component)}
          />

          <Route path={Evento.regist.endpoint} exact
            component={checkAuthorization(Evento.regist, Evento.regist.component)}
          />         

          {/* Tipos de Evento */}
          <Route path={EventType.list.endpoint} exact
            component={checkAuthorization(EventType.list, EventType.list.component)}
          />

          <Route path={EventType.view.endpoint} exact
            component={checkAuthorization(EventType.view, EventType.view.component)}
          />

          <Route path={EventType.regist.endpoint} exact
            component={checkAuthorization(EventType.regist, EventType.regist.component)}
          />

          {/* Forms */}
          <Route path={Forms.list.endpoint} exact
            component={checkAuthorization(Forms.list, Forms.list.component)}
          />

          <Route path={Forms.view.endpoint} exact
            component={checkAuthorization(Forms.view, Forms.view.component)}
          />

          <Route path={Forms.regist.endpoint} exact
            component={checkAuthorization(Forms.regist, Forms.regist.component)}
          />

          {/* Tipos de Forms */}
          <Route path={FormsType.list.endpoint} exact
            component={checkAuthorization(FormsType.list, FormsType.list.component)}
          />

          <Route path={FormsType.view.endpoint} exact
            component={checkAuthorization(FormsType.view, FormsType.view.component)}
          />

          <Route path={FormsType.regist.endpoint} exact
            component={checkAuthorization(FormsType.regist, FormsType.regist.component)}
          />

          {/* Calendar Event */}
          <Route path={Calendar_Event.view.endpoint} exact
            component={checkAuthorization(Calendar_Event.view, Calendar_Event.view.component)}
          />
      
          <Route path={CalendarCopy.view.endpoint} exact
            component={checkAuthorization(CalendarCopy.view, CalendarCopy.view.component)}
          />       

          <Route path={Calendar_Category.list.endpoint} exact
            component={checkAuthorization(Calendar_Category.list, Calendar_Category.list.component)}
          />

          <Route path={Calendar_Category.view.endpoint} exact
            component={checkAuthorization(Calendar_Category.view, Calendar_Category.view.component)}
          />

          <Route path={Calendar_Category.regist.endpoint} exact
            component={checkAuthorization(Calendar_Category.regist, Calendar_Category.regist.component)}
          />

          <Route path={Content.list.endpoint} exact
            component={checkAuthorization(Content.list, Content.list.component)}
          />

          <Route path={Content.view.endpoint} exact
            component={checkAuthorization(Content.view, Content.view.component)}
          />

          <Route path={Content.regist.endpoint} exact
            component={checkAuthorization(Content.regist, Content.regist.component)}
          />

          <Route path={Content_Category.list.endpoint} exact
            component={checkAuthorization(Content_Category.list, Content_Category.list.component)}
          />

          <Route path={Content_Category.view.endpoint} exact
            component={checkAuthorization(Content_Category.view, Content_Category.view.component)}
          />

          <Route path={Content_Category.regist.endpoint} exact
            component={checkAuthorization(Content_Category.regist, Content_Category.regist.component)}
          />

          {/*
          <Route path={Content_Corporate.list.endpoint} exact
            component={checkAuthorization(Content_Corporate.list, Content_Corporate.list.component)}
          />
          */}

          <Route path={Content_Corporate.view.endpoint} exact
            component={checkAuthorization(Content_Corporate.view, Content_Corporate.view.component)}
          />

          <Route path={Content_Corporate.regist.endpoint} exact
            component={checkAuthorization(Content_Corporate.regist, Content_Corporate.regist.component)}
          />


          <Route path={Content_News.list.endpoint} exact
            component={checkAuthorization(Content_News.list, Content_News.list.component)}
          />

          <Route path={Content_News.view.endpoint} exact
            component={checkAuthorization(Content_News.view, Content_News.view.component)}
          />

          <Route path={Content_News.regist.endpoint} exact
            component={checkAuthorization(Content_News.regist, Content_News.regist.component)}
          />

          <Route path={Content_Press.list.endpoint} exact
            component={checkAuthorization(Content_Press.list, Content_Press.list.component)}
          />

          <Route path={Content_Press.view.endpoint} exact
            component={checkAuthorization(Content_Press.view, Content_Press.view.component)}
          />

          <Route path={Content_Press.regist.endpoint} exact
            component={checkAuthorization(Content_Press.regist, Content_Press.regist.component)}
          />

          <Route path={Content_Banner.list.endpoint} exact
            component={checkAuthorization(Content_Banner.list, Content_Banner.list.component)}
          />

          <Route path={Content_Banner.view.endpoint} exact
            component={checkAuthorization(Content_Banner.view, Content_Banner.view.component)}
          />

          <Route path={Content_Banner.regist.endpoint} exact
            component={checkAuthorization(Content_Banner.regist, Content_Banner.regist.component)}
          />

          <Route path={Content_Gallery.list.endpoint} exact
            component={checkAuthorization(Content_Gallery.list, Content_Gallery.list.component)}
          />

          <Route path={Content_Gallery.view.endpoint} exact
            component={checkAuthorization(Content_Gallery.view, Content_Gallery.view.component)}
          />

          <Route path={Content_Gallery.regist.endpoint} exact
            component={checkAuthorization(Content_Gallery.regist, Content_Gallery.regist.component)}
          />

          <Route path={Content_Testemony.list.endpoint} exact
            component={checkAuthorization(Content_Testemony.list, Content_Testemony.list.component)}
          />

          <Route path={Content_Testemony.view.endpoint} exact
            component={checkAuthorization(Content_Testemony.view, Content_Testemony.view.component)}
          />

          <Route path={Content_Testemony.regist.endpoint} exact
            component={checkAuthorization(Content_Testemony.regist, Content_Testemony.regist.component)}
          />


          <Route path={Intranet_Department.list.endpoint} exact
            component={checkAuthorization(Intranet_Department.list, Intranet_Department.list.component)}
          />

          <Route path={Intranet_Department.view.endpoint} exact
            component={checkAuthorization(Intranet_Department.view, Intranet_Department.view.component)}
          />

          <Route path={Intranet_Department.regist.endpoint} exact
            component={checkAuthorization(Intranet_Department.regist, Intranet_Department.regist.component)}
          />

          <Route path={Intranet_Groups.list.endpoint} exact
            component={checkAuthorization(Intranet_Groups.list, Intranet_Groups.list.component)}
          />

          <Route path={Intranet_Groups.view.endpoint} exact
            component={checkAuthorization(Intranet_Groups.view, Intranet_Groups.view.component)}
          />

          <Route path={Intranet_Groups.regist.endpoint} exact
            component={checkAuthorization(Intranet_Groups.regist, Intranet_Groups.regist.component)}
          />

          <Route path={Tarefa.list.endpoint} exact
            component={checkAuthorization(Tarefa.list, Tarefa.list.component)}
          />

          <Route path={Tarefa.view.endpoint} exact
            component={checkAuthorization(Tarefa.view, Tarefa.view.component)}
          />

          <Route path={Tarefa.regist.endpoint} exact
            component={checkAuthorization(Tarefa.regist, Tarefa.regist.component)}
          />

          {/*  PROJETOS */}
          <Route path={Intranet_Projetos.list.endpoint} exact
            component={checkAuthorization(Intranet_Projetos.list, Intranet_Projetos.list.component)}
          />

          <Route path={Intranet_Projetos.view.endpoint} exact
            component={checkAuthorization(Intranet_Projetos.view, Intranet_Projetos.view.component)}
          />

          <Route path={Intranet_Projetos.regist.endpoint} exact
            component={checkAuthorization(Intranet_Projetos.regist, Intranet_Projetos.regist.component)}
          />

          {/*  SUPORTE */}
          <Route path={Intranet_Suporte.list.endpoint} exact
            component={checkAuthorization(Intranet_Suporte.list, Intranet_Suporte.list.component)}
          />

          <Route path={Intranet_Suporte.view.endpoint} exact
            component={checkAuthorization(Intranet_Suporte.view, Intranet_Suporte.view.component)}
          />

          <Route path={Intranet_Suporte.regist.endpoint} exact
            component={checkAuthorization(Intranet_Suporte.regist, Intranet_Suporte.regist.component)}
          />






          <Route path={Intranet_Entity_Category.list.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Category.list, Intranet_Entity_Category.list.component)}
          />

          <Route path={Intranet_Entity_Category.view.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Category.view, Intranet_Entity_Category.view.component)}
          />

          <Route path={Intranet_Entity_Category.regist.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Category.regist, Intranet_Entity_Category.regist.component)}
          />

          <Route path={Intranet_Entity_Dimension.list.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Dimension.list, Intranet_Entity_Dimension.list.component)}
          />

          <Route path={Intranet_Entity_Dimension.view.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Dimension.view, Intranet_Entity_Dimension.view.component)}
          />

          <Route path={Intranet_Entity_Dimension.regist.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Dimension.regist, Intranet_Entity_Dimension.regist.component)}
          />

          <Route path={Intranet_Entity_Function.list.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Function.list, Intranet_Entity_Function.list.component)}
          />

          <Route path={Intranet_Entity_Function.view.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Function.view, Intranet_Entity_Function.view.component)}
          />

          <Route path={Intranet_Entity_Function.regist.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Function.regist, Intranet_Entity_Function.regist.component)}
          />

          <Route path={Intranet_Entity_Nature.list.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Nature.list, Intranet_Entity_Nature.list.component)}
          />

          <Route path={Intranet_Entity_Nature.view.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Nature.view, Intranet_Entity_Nature.view.component)}
          />

          <Route path={Intranet_Entity_Nature.regist.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Nature.regist, Intranet_Entity_Nature.regist.component)}
          />

          <Route path={Intranet_Entity_Relation.list.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Relation.list, Intranet_Entity_Relation.list.component)}
          />

          <Route path={Intranet_Entity_Relation.view.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Relation.view, Intranet_Entity_Relation.view.component)}
          />

          <Route path={Intranet_Entity_Relation.regist.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Relation.regist, Intranet_Entity_Relation.regist.component)}
          />

          <Route path={Intranet_Entity_Sector.list.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Sector.list, Intranet_Entity_Sector.list.component)}
          />

          <Route path={Intranet_Entity_Sector.view.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Sector.view, Intranet_Entity_Sector.view.component)}
          />

          <Route path={Intranet_Entity_Sector.regist.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Sector.regist, Intranet_Entity_Sector.regist.component)}
          />

          <Route path={Intranet_Entity_Type.list.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Type.list, Intranet_Entity_Type.list.component)}
          />

          <Route path={Intranet_Entity_Type.view.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Type.view, Intranet_Entity_Type.view.component)}
          />

          <Route path={Intranet_Entity_Type.regist.endpoint} exact
            component={checkAuthorization(Intranet_Entity_Type.regist, Intranet_Entity_Type.regist.component)}
          />




          {/* 
          <Route path={Intranet_Geral_License.list.endpoint} exact
            component={checkAuthorization(Intranet_Geral_License.list, Intranet_Geral_License.list.component)}
          /> 
          */}

          <Route path={Intranet_Geral_License.view.endpoint} exact
            component={checkAuthorization(Intranet_Geral_License.view, Intranet_Geral_License.view.component)}
          />

          <Route path={Intranet_Geral_License.regist.endpoint} exact
            component={checkAuthorization(Intranet_Geral_License.regist, Intranet_Geral_License.regist.component)}
          />



          <Route path={Intranet_Quality_DocumentType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_DocumentType.list, Intranet_Quality_DocumentType.list.component)}
          />

          <Route path={Intranet_Quality_DocumentType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_DocumentType.view, Intranet_Quality_DocumentType.view.component)}
          />

          <Route path={Intranet_Quality_DocumentType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_DocumentType.regist, Intranet_Quality_DocumentType.regist.component)}
          />

          <Route path={Intranet_Quality_RetentionTime.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_RetentionTime.list, Intranet_Quality_RetentionTime.list.component)}
          />

          <Route path={Intranet_Quality_RetentionTime.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_RetentionTime.view, Intranet_Quality_RetentionTime.view.component)}
          />

          <Route path={Intranet_Quality_RetentionTime.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_RetentionTime.regist, Intranet_Quality_RetentionTime.regist.component)}
          />

          <Route path={Intranet_Quality_StorageType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_StorageType.list, Intranet_Quality_StorageType.list.component)}
          />

          <Route path={Intranet_Quality_StorageType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_StorageType.view, Intranet_Quality_StorageType.view.component)}
          />

          <Route path={Intranet_Quality_StorageType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_StorageType.regist, Intranet_Quality_StorageType.regist.component)}
          />

          <Route path={Intranet_Quality_Document.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Document.list, Intranet_Quality_Document.list.component)}
          />

          <Route path={Intranet_Quality_Document.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Document.view, Intranet_Quality_Document.view.component)}
          />

          <Route path={Intranet_Quality_Document.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Document.regist, Intranet_Quality_Document.regist.component)}
          />


          <Route path={Intranet_Quality_DocumentObsolete.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_DocumentObsolete.list, Intranet_Quality_DocumentObsolete.list.component)}
          />

          <Route path={Intranet_Quality_DocumentDeleted.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_DocumentDeleted.list, Intranet_Quality_DocumentDeleted.list.component)}
          />




          <Route path={Intranet_Quality_OccurrenceType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceType.list, Intranet_Quality_OccurrenceType.list.component)}
          />

          <Route path={Intranet_Quality_OccurrenceType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceType.view, Intranet_Quality_OccurrenceType.view.component)}
          />

          <Route path={Intranet_Quality_OccurrenceType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceType.regist, Intranet_Quality_OccurrenceType.regist.component)}
          />

          <Route path={Intranet_Quality_OccurrenceOrigin.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceOrigin.list, Intranet_Quality_OccurrenceOrigin.list.component)}
          />

          <Route path={Intranet_Quality_OccurrenceOrigin.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceOrigin.view, Intranet_Quality_OccurrenceOrigin.view.component)}
          />

          <Route path={Intranet_Quality_OccurrenceOrigin.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceOrigin.regist, Intranet_Quality_OccurrenceOrigin.regist.component)}
          />

          <Route path={Intranet_Quality_OccurrenceState.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceState.list, Intranet_Quality_OccurrenceState.list.component)}
          />

          <Route path={Intranet_Quality_OccurrenceState.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceState.view, Intranet_Quality_OccurrenceState.view.component)}
          />

          <Route path={Intranet_Quality_OccurrenceState.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_OccurrenceState.regist, Intranet_Quality_OccurrenceState.regist.component)}
          />

          <Route path={Intranet_Quality_Occurrence.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Occurrence.list, Intranet_Quality_Occurrence.list.component)}
          />

          <Route path={Intranet_Quality_Occurrence.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Occurrence.view, Intranet_Quality_Occurrence.view.component)}
          />

          <Route path={Intranet_Quality_Occurrence.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Occurrence.regist, Intranet_Quality_Occurrence.regist.component)}
          />

          <Route path={Intranet_Quality_Strategy.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Strategy.list, Intranet_Quality_Strategy.list.component)}
          />

          <Route path={Intranet_Quality_Strategy.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Strategy.view, Intranet_Quality_Strategy.view.component)}
          />

          <Route path={Intranet_Quality_Strategy.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Strategy.regist, Intranet_Quality_Strategy.regist.component)}
          />

          <Route path={Intranet_Quality_StrategyBetsRisks.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_StrategyBetsRisks.list, Intranet_Quality_StrategyBetsRisks.list.component)}
          />

          <Route path={Intranet_Quality_StrategyBetsRisks.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_StrategyBetsRisks.view, Intranet_Quality_StrategyBetsRisks.view.component)}
          />

          <Route path={Intranet_Quality_StrategyBetsRisks.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_StrategyBetsRisks.regist, Intranet_Quality_StrategyBetsRisks.regist.component)}
          />



          <Route path={Intranet_Quality_AuditManagement.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_AuditManagement.list, Intranet_Quality_AuditManagement.list.component)}
          />

          <Route path={Intranet_Quality_AuditManagement.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_AuditManagement.view, Intranet_Quality_AuditManagement.view.component)}
          />

          <Route path={Intranet_Quality_AuditManagement.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_AuditManagement.regist, Intranet_Quality_AuditManagement.regist.component)}
          />



          <Route path={Intranet_Quality_MonitoringIndicators.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_MonitoringIndicators.list, Intranet_Quality_MonitoringIndicators.list.component)}
          />

          <Route path={Intranet_Quality_MonitoringIndicators.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_MonitoringIndicators.view, Intranet_Quality_MonitoringIndicators.view.component)}
          />

          <Route path={Intranet_Quality_MonitoringIndicators.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_MonitoringIndicators.regist, Intranet_Quality_MonitoringIndicators.regist.component)}
          />



          <Route path={Intranet_Quality_Formation.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Formation.list, Intranet_Quality_Formation.list.component)}
          />

          <Route path={Intranet_Quality_Formation.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Formation.view, Intranet_Quality_Formation.view.component)}
          />

          <Route path={Intranet_Quality_Formation.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_Formation.regist, Intranet_Quality_Formation.regist.component)}
          />



          <Route path={Intranet_Quality_FormationClassificationType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_FormationClassificationType.list, Intranet_Quality_FormationClassificationType.list.component)}
          />

          <Route path={Intranet_Quality_FormationClassificationType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_FormationClassificationType.view, Intranet_Quality_FormationClassificationType.view.component)}
          />

          <Route path={Intranet_Quality_FormationClassificationType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_FormationClassificationType.regist, Intranet_Quality_FormationClassificationType.regist.component)}
          />



          <Route path={Intranet_Quality_FormationStateType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_FormationStateType.list, Intranet_Quality_FormationStateType.list.component)}
          />

          <Route path={Intranet_Quality_FormationStateType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_FormationStateType.view, Intranet_Quality_FormationStateType.view.component)}
          />

          <Route path={Intranet_Quality_FormationStateType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_FormationStateType.regist, Intranet_Quality_FormationStateType.regist.component)}
          />




          <Route path={Intranet_Quality_SupplierEvaluation.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierEvaluation.list, Intranet_Quality_SupplierEvaluation.list.component)}
          />

          <Route path={Intranet_Quality_SupplierEvaluation.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierEvaluation.view, Intranet_Quality_SupplierEvaluation.view.component)}
          />

          <Route path={Intranet_Quality_SupplierEvaluation.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierEvaluation.regist, Intranet_Quality_SupplierEvaluation.regist.component)}
          />

          <Route path={Intranet_Quality_SupplierEvaluationType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierEvaluationType.list, Intranet_Quality_SupplierEvaluationType.list.component)}
          />

          <Route path={Intranet_Quality_SupplierEvaluationType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierEvaluationType.view, Intranet_Quality_SupplierEvaluationType.view.component)}
          />

          <Route path={Intranet_Quality_SupplierEvaluationType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierEvaluationType.regist, Intranet_Quality_SupplierEvaluationType.regist.component)}
          />

          <Route path={Intranet_Quality_SupplierQualityType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierQualityType.list, Intranet_Quality_SupplierQualityType.list.component)}
          />

          <Route path={Intranet_Quality_SupplierQualityType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierQualityType.view, Intranet_Quality_SupplierQualityType.view.component)}
          />

          <Route path={Intranet_Quality_SupplierQualityType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplierQualityType.regist, Intranet_Quality_SupplierQualityType.regist.component)}
          />

          <Route path={Intranet_Quality_SupplyQualityType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplyQualityType.list, Intranet_Quality_SupplyQualityType.list.component)}
          />

          <Route path={Intranet_Quality_SupplyQualityType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplyQualityType.view, Intranet_Quality_SupplyQualityType.view.component)}
          />

          <Route path={Intranet_Quality_SupplyQualityType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplyQualityType.regist, Intranet_Quality_SupplyQualityType.regist.component)}
          />

          <Route path={Intranet_Quality_SupplyType.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplyType.list, Intranet_Quality_SupplyType.list.component)}
          />

          <Route path={Intranet_Quality_SupplyType.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplyType.view, Intranet_Quality_SupplyType.view.component)}
          />

          <Route path={Intranet_Quality_SupplyType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_SupplyType.regist, Intranet_Quality_SupplyType.regist.component)}
          />

          {/* 
          <Route path={Intranet_Quality_License.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_License.list, Intranet_Quality_License.list.component)}
          /> 
          */}

          <Route path={Intranet_Quality_License.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_License.view, Intranet_Quality_License.view.component)}
          />

          <Route path={Intranet_Quality_License.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_License.regist, Intranet_Quality_License.regist.component)}
          />


          {/* 
          <Route path={Intranet_Maintenance_License.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_License.list, Intranet_Maintenance_License.list.component)}
          /> 
          */}

          <Route path={Intranet_Maintenance_License.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_License.view, Intranet_Maintenance_License.view.component)}
          />

          <Route path={Intranet_Maintenance_License.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_License.regist, Intranet_Maintenance_License.regist.component)}
          />

          {/*
          <Route path={Intranet_CRM_License.list.endpoint} exact
            component={checkAuthorization(Intranet_CRM_License.list, Intranet_CRM_License.list.component)}
          /> 
          */}

          <Route path={Intranet_CRM_License.view.endpoint} exact
            component={checkAuthorization(Intranet_CRM_License.view, Intranet_CRM_License.view.component)}
          />

          <Route path={Intranet_CRM_License.regist.endpoint} exact
            component={checkAuthorization(Intranet_CRM_License.regist, Intranet_CRM_License.regist.component)}
          />

          <Route path={Intranet_CRM_Opportunity.list.endpoint} exact
            component={checkAuthorization(Intranet_CRM_Opportunity.list, Intranet_CRM_Opportunity.list.component)}
          />

          <Route path={Intranet_CRM_Opportunity.view.endpoint} exact
            component={checkAuthorization(Intranet_CRM_Opportunity.view, Intranet_CRM_Opportunity.view.component)}
          />

          <Route path={Intranet_CRM_Opportunity.regist.endpoint} exact
            component={checkAuthorization(Intranet_CRM_Opportunity.regist, Intranet_CRM_Opportunity.regist.component)}
          />

          <Route path={Intranet_Quality_EPI.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_EPI.list, Intranet_Quality_EPI.list.component)}
          />

          <Route path={Intranet_Quality_EPI.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_EPI.view, Intranet_Quality_EPI.view.component)}
          />

          <Route path={Intranet_Quality_EPI.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_EPI.regist, Intranet_Quality_EPI.regist.component)}
          />

          <Route path={Intranet_Quality_EPI_Type.list.endpoint} exact
            component={checkAuthorization(Intranet_Quality_EPI_Type.list, Intranet_Quality_EPI_Type.list.component)}
          />

          <Route path={Intranet_Quality_EPI_Type.view.endpoint} exact
            component={checkAuthorization(Intranet_Quality_EPI_Type.view, Intranet_Quality_EPI_Type.view.component)}
          />

          <Route path={Intranet_Quality_EPI_Type.regist.endpoint} exact
            component={checkAuthorization(Intranet_Quality_EPI_Type.regist, Intranet_Quality_EPI_Type.regist.component)}
          />

          <Route path={Intranet_CRM_StageType.list.endpoint} exact
            component={checkAuthorization(Intranet_CRM_StageType.list, Intranet_CRM_StageType.list.component)}
          />

          <Route path={Intranet_CRM_StageType.view.endpoint} exact
            component={checkAuthorization(Intranet_CRM_StageType.view, Intranet_CRM_StageType.view.component)}
          />

          <Route path={Intranet_CRM_StageType.regist.endpoint} exact
            component={checkAuthorization(Intranet_CRM_StageType.regist, Intranet_CRM_StageType.regist.component)}
          />

          <Route path={Intranet_CRM_ComType.list.endpoint} exact
            component={checkAuthorization(Intranet_CRM_ComType.list, Intranet_CRM_ComType.list.component)}
          />

          <Route path={Intranet_CRM_ComType.view.endpoint} exact
            component={checkAuthorization(Intranet_CRM_ComType.view, Intranet_CRM_ComType.view.component)}
          />

          <Route path={Intranet_CRM_ComType.regist.endpoint} exact
            component={checkAuthorization(Intranet_CRM_ComType.regist, Intranet_CRM_ComType.regist.component)}
          />

          <Route path={Intranet_Maintenance_ActiveType.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_ActiveType.list, Intranet_Maintenance_ActiveType.list.component)}
          />

          <Route path={Intranet_Maintenance_ActiveType.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_ActiveType.view, Intranet_Maintenance_ActiveType.view.component)}
          />

          <Route path={Intranet_Maintenance_ActiveType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_ActiveType.regist, Intranet_Maintenance_ActiveType.regist.component)}
          />

          <Route path={Intranet_Maintenance_ActiveState.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_ActiveState.list, Intranet_Maintenance_ActiveState.list.component)}
          />

          <Route path={Intranet_Maintenance_ActiveState.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_ActiveState.view, Intranet_Maintenance_ActiveState.view.component)}
          />

          <Route path={Intranet_Maintenance_ActiveState.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_ActiveState.regist, Intranet_Maintenance_ActiveState.regist.component)}
          />

          <Route path={Intranet_Maintenance_Active.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Active.list, Intranet_Maintenance_Active.list.component)}
          />

          <Route path={Intranet_Maintenance_Active.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Active.view, Intranet_Maintenance_Active.view.component)}
          />

          <Route path={Intranet_Maintenance_Active.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Active.regist, Intranet_Maintenance_Active.regist.component)}
          />
          {/* Planeamento*/}
          <Route path={Intranet_Maintenance_Maintenance_Planeamento.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Maintenance_Planeamento.list, Intranet_Maintenance_Maintenance_Planeamento.list.component)}
          />
          <Route path={Intranet_Maintenance_Maintenance_Planeamento.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Maintenance_Planeamento.view, Intranet_Maintenance_Maintenance_Planeamento.view.component)}
          />
          <Route path={Intranet_Maintenance_Maintenance_Planeamento.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Maintenance_Planeamento.regist, Intranet_Maintenance_Maintenance_Planeamento.regist.component)}
          />

          {/*Intervenção*/}
          <Route path={Intranet_Maintenance_Intervention.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Intervention.list, Intranet_Maintenance_Intervention.list.component)}
          />
          <Route path={Intranet_Maintenance_Intervention.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Intervention.regist, Intranet_Maintenance_Intervention.regist.component)}
          />
          <Route path={Intranet_Maintenance_Intervention.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Intervention.view, Intranet_Maintenance_Intervention.view.component)}
          />

          {/* Periodicidade*/}
          <Route path={Intranet_Maintenance_Periodicity.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Periodicity.list, Intranet_Maintenance_Periodicity.list.component)}
          />
          <Route path={Intranet_Maintenance_Periodicity.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Periodicity.regist, Intranet_Maintenance_Periodicity.regist.component)}
          />
          <Route path={Intranet_Maintenance_Periodicity.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Periodicity.view, Intranet_Maintenance_Periodicity.view.component)}
          />

          {/* Prioridade*/}
          <Route path={Intranet_Maintenance_Priority.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Priority.list, Intranet_Maintenance_Priority.list.component)}
          />
          <Route path={Intranet_Maintenance_Priority.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Priority.regist, Intranet_Maintenance_Priority.regist.component)}
          />
          <Route path={Intranet_Maintenance_Priority.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Priority.view, Intranet_Maintenance_Priority.view.component)}
          />

          {/* Reparação*/}
          <Route path={Intranet_Maintenance_RepairType.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_RepairType.list, Intranet_Maintenance_RepairType.list.component)}
          />

          <Route path={Intranet_Maintenance_RepairType.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_RepairType.view, Intranet_Maintenance_RepairType.view.component)}
          />

          <Route path={Intranet_Maintenance_RepairType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_RepairType.regist, Intranet_Maintenance_RepairType.regist.component)}
          />

          {/* Tipos de Reparação */}
          <Route path={Intranet_Maintenance_Repair.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Repair.list, Intranet_Maintenance_Repair.list.component)}
          />

          <Route path={Intranet_Maintenance_Repair.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Repair.view, Intranet_Maintenance_Repair.view.component)}
          />

          <Route path={Intranet_Maintenance_Repair.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Repair.regist, Intranet_Maintenance_Repair.regist.component)}
          />

          {/* Ordens de Manutenção */}
          <Route path={Intranet_Maintenance_Orders.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Orders.list, Intranet_Maintenance_Orders.list.component)}
          />

          <Route path={Intranet_Maintenance_Orders.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Orders.view, Intranet_Maintenance_Orders.view.component)}
          />

          <Route path={Intranet_Maintenance_Orders.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Orders.regist, Intranet_Maintenance_Orders.regist.component)}
          />

          {/* Custos de Manutenção */}
          <Route path={Intranet_Maintenance_Cost.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Cost.list, Intranet_Maintenance_Cost.list.component)}
          />

          <Route path={Intranet_Maintenance_Cost.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Cost.view, Intranet_Maintenance_Cost.view.component)}
          />

          <Route path={Intranet_Maintenance_Cost.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Cost.regist, Intranet_Maintenance_Cost.regist.component)}
          />

          <Route path={Intranet_Maintenance_RMMType.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_RMMType.list, Intranet_Maintenance_RMMType.list.component)}
          />

          <Route path={Intranet_Maintenance_RMMType.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_RMMType.view, Intranet_Maintenance_RMMType.view.component)}
          />

          <Route path={Intranet_Maintenance_RMMType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_RMMType.regist, Intranet_Maintenance_RMMType.regist.component)}
          />

          {/* Gestão de Energia */}
          <Route path={Intranet_Maintenance_Energy.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Energy.list, Intranet_Maintenance_Energy.list.component)}
          />

          <Route path={Intranet_Maintenance_Energy.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Energy.view, Intranet_Maintenance_Energy.view.component)}
          />

          <Route path={Intranet_Maintenance_Energy.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Energy.regist, Intranet_Maintenance_Energy.regist.component)}
          />

          {/* Tipos de Energia */}
          <Route path={Intranet_Maintenance_EnergyType.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_EnergyType.list, Intranet_Maintenance_EnergyType.list.component)}
          />

          <Route path={Intranet_Maintenance_EnergyType.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_EnergyType.view, Intranet_Maintenance_EnergyType.view.component)}
          />

          <Route path={Intranet_Maintenance_EnergyType.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_EnergyType.regist, Intranet_Maintenance_EnergyType.regist.component)}
          />

          {/*   <Route path="/" exact component={Main} />Main */}

          <Route path={Main.view.endpoint} exact component={Main.view.component} />

          {/* <Route path="/corporate" exact component={
            checkAuthorization("/corporate", Corporate)
          } /> */}

          <Route path="/recovery" exact component={Recuperar} />



          <Route path={AppPerfil.regist.endpoint} exact
            component={checkAuthorization(AppPerfil.regist.endpoint, AppPerfil.regist.component)} />

          <Route path={AppPerfil.list.endpoint} exact
            component={checkAuthorization(AppPerfil.list.endpoint, AppPerfil.list.component)} />

          <Route path={AppPerfil.view.endpoint} exact
            component={checkAuthorization(AppPerfil.view.endpoint, AppPerfil.view.component)} />


          <Route path={EntityPerfil.regist.endpoint} exact
            component={checkAuthorization(EntityPerfil.regist.endpoint, EntityPerfil.regist.component)} />

          <Route path={EntityPerfil.list.endpoint} exact
            component={checkAuthorization(EntityPerfil.list.endpoint, EntityPerfil.list.component)} />

          <Route path={EntityPerfil.view.endpoint} exact
            component={checkAuthorization(EntityPerfil.view.endpoint, EntityPerfil.view.component)} />




          {/* Gestão de Energia */}
          <Route path={Intranet_Maintenance_Energy.list.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Energy.list, Intranet_Maintenance_Energy.list.component)}
          />

          <Route path={Intranet_Maintenance_Energy.view.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Energy.view, Intranet_Maintenance_Energy.view.component)}
          />

          <Route path={Intranet_Maintenance_Energy.regist.endpoint} exact
            component={checkAuthorization(Intranet_Maintenance_Energy.regist, Intranet_Maintenance_Energy.regist.component)}
          />


          {/* QUANDO O ENDEREÇO NÃO É VÝLIDO */}
          {/* <Route path='*' component={() => <Redirect to="/" />} /> */}
          <Route path='*' component={() => <Redirect to="/" />} />

        </Switch >
      </div >
      <Footer />

    </>

}

export default App;


/*

    <Route path="/corporate" exact={true} component={Corporate} />
             <Corporate inputsContent={CorporateContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />    </Route>


        <Route path="/user" exact>
          <User inputsContent={UserContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />
        </Route>

        <Route path="/preferences" >
          <Preferences />
        </Route>

        <Route path="/datatable">
          <DataTable
                                    noDataComponent='Sem Registos'Example />
        </Route>

        <Route path="/datatable2">
          <DataTable
                                    noDataComponent='Sem Registos'Example2 />
        </Route>

        <Route path="/form">
          <FormTemplate inputsContent={FormContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />
        </Route>
        */


/*

import ColaboradorLista from './components/Colaborador/ColaboradorLista';
import Colaborador from './components/Colaborador/Colaborador';
import ColaboradorView from './components/Colaborador/ColaboradorView';

import PromotorLista from './components/Promotor/PromotorLista';
import Promotor from './components/Promotor/Promotor';
import PromotorView from './components/Promotor/PromotorView';

import EscritorioLista from './components/Escritorio/EscritorioLista';
import Escritorio from './components/Escritorio/Escritorio';
import EscritorioView from './components/Escritorio/EscritorioView';

import MasterBlank from './components/Master/MasterBlank';
import MasterLista from './components/Master/MasterLista';
import Master from './components/Master/Master';

*/